module.exports = __webpack_public_path__ + "img/no_email.1bbd254f.svg";